import { Fragment,useState } from 'react'
import { Marker, Popup, MapContainer, TileLayer, useMap } from 'react-leaflet'

import 'leaflet/dist/leaflet.css';


const ROIEditor = ({title, submitter }) => {

  const herrenChiemsee=[47.860493,12.401420 ]
  const tum = [48.054533,11.653311 ];
  //const map = useMap(); goes to a child
  const navigateMap = (loc)=>{
  console.log(loc);
}

   return (<><h2>Region of Interest</h2>

<MapContainer center={tum} zoom={18} scrollWheelZoom={false} style={{height:"320px"}}>
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  />
</MapContainer>

<ul>
<li><a onClick={() => {navigateMap(tum);}}> TUM Building</a></li>
<li><a onClick={() => {navigateMap(herrenChiemsee);}}> Schloss Herrenchiemsee</a></li>
</ul>
</>);
};
export default ROIEditor;